import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Group_Interface, General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DorehAmoozeshiService } from 'src/app/Service/DorehAmoozeshi/DorehAmoozeshi.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DorehAmoozeshiList',
  templateUrl: './DorehAmoozeshiList.component.html',
  styleUrls: ['./DorehAmoozeshiList.component.scss']
})
export class DorehAmoozeshiListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DorehAmoozeshi_Service:DorehAmoozeshiService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_DorehAmoozeshi:Array<General_Group_Interface>=[]
  Data_Seleted_Delete:General_Group_Interface=Empty_General_Group_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,26).subscribe(
      data=>{
        this.ReadData_DorehAmoozeshi()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_DorehAmoozeshi(){
    this.Procssing=true
    this.DorehAmoozeshi_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_DorehAmoozeshi=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Group_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.DorehAmoozeshi_Service.DeleteDorehAmoozeshi(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.ReadData_DorehAmoozeshi()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
